import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import api from '../api/api';

import '../styles/Blog.css';
import Header from "./Components/Header";
import FooterWithSignup from "./Components/FooterWithSignup";
import {IMAGE_URL} from "../path";
import BlogHeading from "./Components/BlogComponents/BlogHeading";
import BlogParagraph from "./Components/BlogComponents/BlogParagraph";
import BlogImage from "./Components/BlogComponents/BlogImage";
import BlogTwoImages from "./Components/BlogComponents/BlogTwoImages";

function Blog() {
    const { slug } = useParams();

    const [blog, setBlog] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState<any>(null);
    const [components, setComponents] = useState<any>([]);
    const url = window.location.href;
    const title = blog?.title;
    // const url = `https://denny.co.za`

    const handleInstagramShare = async () => {
        const url = window.location.href;

        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (navigator.share && isMobile) {
            try {
                await navigator.share({
                    title: blog.title,
                    text: blog.subtitle,
                    url,
                });
                return;
            } catch (err: any) {
                console.error(err);
                alert(`${err.name}: ${err.message}`);
                return;
            }
        }

        try {
            await navigator.clipboard.writeText(url);
            alert("Link copied to clipboard. You can now paste it into Instagram.");
        } catch {
            alert("Unable to copy the link.");
        }
    };

    useEffect(() => {
        if (!slug) {
            return;
        }

        const loadBlog = async () => {
            try {
                const response = await api.get(
                    `/fetch-single-blog/${slug}`
                );

                setBlog(response.data.blog);
                setCategory(response.data.category);
                setComponents(response.data.components);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        loadBlog();
    }, [slug]);

    if (loading) {
        return (
            <div className="blog-page">
                <Header />

                <div className="blog-page-main">
                    <div className="blog-page-header-image">
                        <div className="skeleton blog-cover-skeleton" />
                    </div>

                    <div className="blog-page-header-details">
                        <div className="blog-page-header-details-left">
                            <div className="skeleton blog-title-skeleton" />
                            <div className="skeleton blog-title-short-skeleton" />
                        </div>

                        <div className="blog-page-header-details-right">
                            <div className="skeleton blog-meta-skeleton" />
                            <div className="skeleton blog-meta-skeleton" />
                        </div>
                    </div>

                    <div className="blog-body">
                        <div className="skeleton blog-heading-skeleton" />

                        <div className="skeleton blog-line" />
                        <div className="skeleton blog-line" />
                        <div className="skeleton blog-line short" />

                        <div className="skeleton blog-image-skeleton" />

                        <div className="skeleton blog-heading-skeleton small" />

                        <div className="skeleton blog-line" />
                        <div className="skeleton blog-line" />
                        <div className="skeleton blog-line" />
                        <div className="skeleton blog-line short" />

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "24px",
                                marginTop: "40px",
                            }}
                        >
                            <div className="skeleton blog-image-skeleton" />
                            <div className="skeleton blog-image-skeleton" />
                        </div>
                    </div>

                    <div className="blog-page-footer">
                        <div className="skeleton blog-share-text" />

                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                            }}
                        >
                            <div className="skeleton blog-share-icon" />
                            <div className="skeleton blog-share-icon" />
                            <div className="skeleton blog-share-icon" />
                        </div>
                    </div>
                </div>

                <FooterWithSignup />
            </div>
        );
    }


    return (
        <div className="blog-page">
            <Header />
            <div className="blog-page-main">
                <div className="blog-page-header-image">
                    <img src={`${IMAGE_URL}${blog?.cover_image}`} alt={blog?.title} />
                </div>
                <div className="blog-page-header-details">
                    <div className="blog-page-header-details-left">
                        <h2>{blog?.title}</h2>
                    </div>
                    <div className="blog-page-header-details-right">
                        <p>{category?.name}</p>
                        <p>{new Date(blog?.published_at).toLocaleDateString("en-GB")}</p>
                    </div>
                </div>
                <div className="blog-body">
                    {components?.map((item: any, i: number) => {
                        switch (item.component_type) {
                            case "heading":
                                return <BlogHeading heading={item?.heading_section?.heading} key={i} />;

                            case "body":
                                return <BlogParagraph paragraph={item?.body_section?.body} key={i} />;

                            case "image":
                                return <BlogImage image_url={item?.image_section?.image} key={i} />;

                            case "two_images":
                                return <BlogTwoImages image_1_url={item?.two_image_section?.image_1} image_2_url={item?.two_image_section?.image_2} key={i} />;

                            default:
                                return null;
                        }
                    })}
                </div>
                <div className="blog-page-footer">
                    <div className="blog-page-footer-left">Share this blog</div>
                    <div className="blog-page-footer-right">
                        <div className="icon">
                            <a
                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path fill="#fff" d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.6-1.6h1.7V4.8c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.2V11H8v3h2.7v8h2.8z"/>
                                </svg>
                            </a>

                        </div>
                        <div className="icon instagram" onClick={() => handleInstagramShare()}>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path fill="#fff" d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3.5A4.5 4.5 0 1 0 16.5 12 4.5 4.5 0 0 0 12 7.5zm0 2A2.5 2.5 0 1 1 9.5 12 2.5 2.5 0 0 1 12 9.5zm5-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/>
                                </svg>

                        </div>
                        <div className="icon email">
                            <a
                                href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`}
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16">
                                <path id="Path_14071" data-name="Path 14071" d="M22.25,6.75v10.5a2.279,2.279,0,0,1-2.308,2.25H4.558A2.279,2.279,0,0,1,2.25,17.25V6.75m20,0A2.279,2.279,0,0,0,19.942,4.5H4.558A2.279,2.279,0,0,0,2.25,6.75m20,0v.243a2.238,2.238,0,0,1-1.1,1.916L13.46,13.524a2.358,2.358,0,0,1-2.421,0L3.347,8.91a2.238,2.238,0,0,1-1.1-1.916V6.75" transform="translate(-1.75 -4)" fill="#fff" stroke="#436AB3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                            </svg>
                            </a>

                        </div>
                    </div>
                </div>
            </div>

            <FooterWithSignup />
        </div>
    );
}

export default Blog;
